import config from './config';
const { aegisId, bugly, h5AegisId } = config;
let Aegis = null;
// eslint-disable-next-line import/no-mutable-exports
let aegis;

const H5Aegis = require('@tencent/aegis-web-sdk');
Aegis = H5Aegis;




const aegisPluginConfig = {
  // id: aegisId, // 项目ID
  uin: config.env !== 'production' ? config.env : '', // 通用用来监控某个特定用户的常规日志上报
  env: config.env || '', // 环境
  reportApiSpeed: true, // 接口测速
  pagePerformance: true,
  offlineLog: true,
  offlineLogExp: 7,
  api: {
    // 设置上报规则
    retCodeHandler(data) {
      let isErr = false;
      let code = 0;
      try {
        if (Object.prototype.toString.call(data) === '[object Object]') {
          if (data.body) {
            isErr = !(
              (data.body.bizcode === 0 && data.body.retcode === 0) ||
              (data.body.bizcode === 0 && data.body.retcode === 1004) ||
              (data.body.bizcode === 0 && data.body.retcode === 1014)
            );
            code = data.body.retcode || data.body.bizcode;
          }
        }
      } catch (e) {
        console.log(e);
      }

      return {
        isErr,
        code,
      };
    },
    // 非生产环境开启接口详情上报，便于排查问题
    apiDetail: config.env !== 'production',
  },
  spa: true,
  reportAssetSpeed: true, // 静态资源测速
  
};
let defaultConfig = {};
defaultConfig = {
  id: h5AegisId || aegisId, // 项目ID
  ...aegisPluginConfig,
};




// 微信下，通过异步化js的方式获取表达式。使用__non_webpack_require__构建后，方法还能保持require.async，否则会被打包成 __webpack__.require


aegis = new Aegis(defaultConfig);


let canReport;
let reportStart;
let reportEnd;
let events = [];



// 页面跳转路径上报
const reportPageNavigation = (fromPath, toPath, additionalInfo = {}) => {
  const reportData = {
    name: 'page_navigation',
    ext1: fromPath,
    ext2: toPath,
    ext3: additionalInfo.ext3 || JSON.stringify(additionalInfo)
  };
  console.log('页面跳转上报:', reportData);
  aegis.reportEvent(reportData);
};

// 无权限页面上报
const reportPermissionDenied = (pagePath, permissionType, userInfo = {}, additionalInfo = {}) => {
  const reportData = {
    name: 'permission_denied',
    ext1: permissionType, // layout 或 data
    ext2: pagePath,
    ext3: userInfo.uin || JSON.stringify(userInfo)
  };
  console.log('无权限上报:', reportData);
  aegis.reportEvent(reportData);
  // 同时作为错误上报
  aegis.error({
    name: 'PermissionDeniedError',
    msg: `用户无${permissionType === 'layout' ? '布局' : '数据'}权限访问页面: ${pagePath}`,
    ext1: permissionType,
    ext2: pagePath,
    ext3: JSON.stringify(userInfo)
  });
};

// 通用自定义事件上报
const reportCustomEvent = (eventName, eventData = {}) => {
  const reportData = {
    name: eventName,
    ext1: eventData.ext1 || '',
    ext2: eventData.ext2 || '',
    ext3: eventData.ext3 || ''
  };
  console.log('自定义事件上报:', reportData);
  aegis.reportEvent(reportData);
};

// 用户行为上报
const reportUserAction = (action, target, context = {}) => {
  
  const reportData = {
    name: 'user_action',
    ext1: action,
    ext2: target,
    ext3: window.location.pathname
  };
  console.log('用户行为上报:', reportData);
  aegis.reportEvent(reportData);
  
};

export {
  reportStart,
  reportEnd,
  reportPageNavigation,
  reportPermissionDenied,
  reportCustomEvent,
  reportUserAction,
};
export default aegis;
